<template>
  <v-app id="inspire">
    <v-card-title>
      Production licenses
      <v-spacer></v-spacer>
      <v-dialog width="unset" height="unset" v-model="dialogs.registerNew">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="ml-5" color="secondary" v-bind="attrs" v-on="on"
            >Register unit</v-btn
          >
        </template>
        <v-card class="pa-2" background="white">
          <v-card-title> Create production license for new unit </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="my-3">
            <v-select
              v-model="newUnit.unitTypeId"
              :items="availableUnitTypes"
              label="Unit type"
              outlined
            ></v-select>
            <v-text-field v-model="newUnit.unitId" label="Unit GUID" outlined>
            </v-text-field>
            <v-text-field
              v-model="newUnit.macAddress"
              label="MAC Address"
              outlined
            >
            </v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="dialogs.registerNew = false"
              >close</v-btn
            >
            <v-btn
              color="primary"
              @click="
                createProductionLicense(newUnit);
                dialogs.registerNew = false;
              "
              >Create license</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :search="search"
      :custom-filter="filterProductionLicenses"
      :items="getAllProductionLicenses"
      :hide-default-footer="true"
      :loading="$apollo.queries.getAllProductionLicenses.loading"
      disable-pagination
      item-key="unitIdentity.unitId"
      @click:row="refetchProductionLicenses()"
    >
      <template v-slot:item.actions="{ item, attrs, on }">
        <!-- RESET PASSWORD FILE DOWNLOAD BUTTON -->
        <v-btn
          v-if="item.unitIdentity.unitTypeId === 'EHUB'"
          icon
          v-bind="attrs"
          v-on="on"
          @click="generatePasswordResetFile(item.unitIdentity.unitId)"
        >
          <v-icon>mdi-lock-reset</v-icon>
        </v-btn>
        <!-- DOWNLOAD LICENSE BUTTON -->
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          @click="getSignedLicense(item.licenseInfo.licenseId)"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <!-- DELETE PACKAGE BUTTON -->
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          @click="deleteLicense(item.licenseInfo.licenseId)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <c-confirmation-dialog ref="confirmationDialog"></c-confirmation-dialog>
  </v-app>
</template>
<style scoped></style>
<script>
import {
  GET_ALL_PRODUCTION_LICENSES_QUERY,
  GET_SIGNED_LICENSE_QUERY,
  GET_EHUB_RESET_TOKEN,
  CREATE_PRODUCTION_LICENSE,
  DELETE_LICENSE,
} from "../../graphql/licenseQueries.js";

export default {
  created() {},
  components: {
    CConfirmationDialog: () => import("../common/CConfirmationDialog"),
  },
  data() {
    return {
      loading: true,
      getAllProductionLicenses: [],
      newUnit: {
        unitId: "",
        unitTypeId: "",
        macAddress: "",
      },
      dialogs: {
        registerNew: false,
      },
      availableUnitTypes: ["ETARGET", "EHUB", "ADMIN", "UPGRADE", "PEGASUS"],
      search: "",
      headers: [
        { text: "Unit Type", value: "unitIdentity.unitTypeId", sortable: true },
        { text: "ID", value: "unitIdentity.unitId", sortable: false },
        { text: "MAC", value: "unitIdentity.macAddress", sortable: false },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "right",
        },
      ],
    };
  },
  apollo: {
    $client: "licenseClient",
    getAllProductionLicenses: {
      query: GET_ALL_PRODUCTION_LICENSES_QUERY,
      loadingKey: "loading",
    },
  },
  methods: {
    /* Custom filter for the search bar */
    filterProductionLicenses(value, search, item) {
      return item.unitIdentity.unitId
        .toLowerCase()
        .includes(search.toLowerCase());
    },
    async createProductionLicense(unit) {
      try {
        await this.$apollo.mutate({
          mutation: CREATE_PRODUCTION_LICENSE,
          variables: {
            unitTypeId: unit.unitTypeId,
            unitId: unit.unitId,
            macAddress: unit.macAddress,
          },
        });
        this.newUnit = {
          unitId: "",
          macAddress: "",
        };
      } catch (error) {
        alert("The service was not able to create production license.");
        console.error(error);
      }

      this.refetchProductionLicenses();
    },
    async getSignedLicense(licenseId) {
      try {
        console.log("getSignedLicense " + licenseId);
        const response = await this.$apollo.mutate({
          mutation: GET_SIGNED_LICENSE_QUERY,
          variables: {
            licenseId: licenseId,
          },
        });
        this.downloadFile("production.lic", response.data.getSignedLicense);
      } catch (error) {
        alert("The license could not be found.");
        console.error(error);
      }
    },
    downloadFile(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    refetchProductionLicenses() {
      this.$apollo.queries.getAllProductionLicenses.refetch();
    },
    async deleteLicense(id) {
      console.log(this.$refs.confirmationDialog);
      if (
        await this.$refs.confirmationDialog.open(
          "Are you sure you want to delete this license?"
        )
      ) {
        try {
          const response = await this.$apollo.mutate({
            mutation: DELETE_LICENSE,
            variables: {
              id: id,
            },
          });
          console.log(response);
          this.refetchProductionLicenses();
        } catch (error) {
          alert("Error deleting license! " + error.message);
        }
      }
    },
    async generatePasswordResetFile(ehubId) {
      const response = await this.$apollo.mutate({
        client: "licenseClient",
        mutation: GET_EHUB_RESET_TOKEN,
        variables: {
          ehubId: ehubId,
        },
      });

      const token = response.data.getEhubResetToken;

      if (!token) {
        console.error("No password reset token received");
        return;
      }

      this.downloadFile(ehubId + ".reset", token);
    },
  },
};
</script>
